import { FC, useEffect, useState } from 'react';
import { CheckboxInput, Wrapper } from '../styles';
import { CheckboxProps } from '../types';
import { Typography } from 'shared/ui/typography';

export const Checkbox: FC<CheckboxProps> = ({
	children,
	onChange,
	isChecked = false,
  direction,
  gap,
  mode,
  setHandle = true,
}) => {
	const [checked, setChecked] = useState(isChecked);

	const handleChange = () => {
		onChange?.(!checked);
    if (setHandle) {
      setChecked(!checked);
    }
	};

	useEffect(() => {
		setChecked(isChecked);
	}, [isChecked]);

	return (
		<Wrapper $direction={direction} $gap={gap}>
			<CheckboxInput
				type="checkbox"
				id="checkbox"
				onChange={handleChange}
				checked={checked}
			/>
			<Typography 
        pointer={true} 
        onClick={!window.matchMedia("(pointer: coarse)").matches ? handleChange : undefined} 
        onTouchStart={handleChange}
        mode={mode}
      >
				{children}
			</Typography>
		</Wrapper>
	);
};
